import { ItemService } from "@/services/nextshop/item.service";

export default {
  methods: {
    async genBarcode(quantity) {
      try {
        const req = {
          quantity : quantity,
        }
        const response = await ItemService.genBarcode(req)
        if (response.success) {
          return response.data.upcs
        }
      }
      catch (error) {
        console.log(error); 
      }
    },

    async updateItemBarcode(ids, override) {
      try {
        const req = {
          itemIds: ids,
          override: override
        }
        const response = await ItemService.updateBarcode(req)
        if (response.success) {
          return response.data
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
